import React from 'react';
import Banner from './Banner';
import ServicesFive from './ServicesFive';
import AboutFour from './AboutFour';
import BrandTwo from './BrandTwo';
import ProjectFour from './ProjectFour';
import SlidingTextOne from '../../components/Common/SlidingTextOne ';
import ContactThree from './ContactThree';
import WhyWe from './WhyWe';
import VideoOne from './VideoOne';
import QualityWork from './QualityWork';
import TestimonialThree from './TestimonialThree';
import BlogThree from './BlogThree';



const HomeFourMain = () => {
	return (
		<>
			<Banner />
			<ServicesFive />
			<AboutFour />
			<BrandTwo />
			<ProjectFour />
			<SlidingTextOne />
			<ContactThree />
			<WhyWe />
			<VideoOne />
			<QualityWork />
			<TestimonialThree />
			<BlogThree />
		</>
	);
}

export default HomeFourMain;
